// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"382249ae","239":"69d2c352","298":"cd4a040f","453":"a76c794c","455":"27d13769"}[chunkId] + ".chunk.js";
};